<template>
    <div class="outer">


        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="操作行为" class="queryCol">
                    <el-select v-model="queryForm.outInFlag" @change="onSearch" clearable @clear="onSearch">
                        <el-option :value="1" label="入库">入库</el-option>
                        <el-option :value="-1" label="出库">出库</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table
        v-loading="loading"
        style="width: 100%;overflow: auto;height: 68vh;"
        :row-style="{ height: '58px' }"
        :data="tableData">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column
            align="center"
            label="货物名称"
            prop="goodsName">
            </el-table-column>
            <el-table-column
            align="center"
            label="采购单编号"
            prop="purchaseNo">
            </el-table-column>
            <el-table-column
            align="center"
            label="项目名称"
            prop="projectName">
                <template slot-scope="scope">
                    {{ scope.row.outInFlag === 1 ? scope.row.projectName : scope.row.outForChanceName || '--' }}
                </template>
            </el-table-column>
            <el-table-column
            align="center"
            label="供应商名称"
            prop="supplierName">
            </el-table-column>
            <el-table-column
            align="center"
            label="操作行为"
            prop="outInFlag">
                <template slot-scope="scope">
                    <el-tag type="primary" effect="dark" v-if="scope.row.outInFlag === 1 && scope.row.purchaseState == 0">
                        退货入库
                    </el-tag>
                    <el-tag type="primary" effect="dark" v-if="scope.row.outInFlag === 1 && scope.row.purchaseState == 1">
                        入库
                    </el-tag>
                    <el-tag v-if="scope.row.outInFlag === -1">
                        出库
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            align="center"
            label="数量"
            width="80"
            prop="goodsNum">
            </el-table-column>
            <el-table-column
            align="center"
            label="处理人"
            prop="dealUserName">
            </el-table-column>
            <el-table-column
            align="center"
            label="备注"
            prop="remarks">
                <template slot-scope="scope">
                    {{ scope.row.remarks || '--' }}
                </template>
            </el-table-column>
            <el-table-column
            align="center"
            label="时间"
            prop="createTime"
            min-width="130"
            
            :formatter="dateTimeTwoLine"
            class-name="cell-two-line"
            >
            <template slot-scope="scope">
                {{ scope.row.createTime.split('.')[0].replace('T','   ')}}
            </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination    
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :total="total"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :current-page="page"
            background
            layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { queryOutInDetails } from '@/api/goods/inventory.js';
export default {
   data() {
      return {
        buyOrderList: [], // 货物明细采购单列表
        outboundVisable: false, // 出库弹窗显隐
        outForm: {},
        total: 0, // 总条目数
        pageSize: 10,
        page: 1,
        DialogTitle: '', // 弹窗标题
        tableData: [],
        loading: false,
        queryForm: {
            outInFlag: ''
        },
        classOptions:[]
      }
   },
   created(){
        this.getTableData();
   },
   computed:{
   },
   methods:{
    getTableData(){
        this.loading = true
        queryOutInDetails({
            "page": this.page,
            "limit": this.pageSize,
            "outInFlag": this.queryForm.outInFlag, //出入库标志
        }).then(res => {
            if(res.code === 200){
                this.loading = false;
                this.total = res.total;
                this.tableData = res.data;
            }
        })
    },
    
    // 当每页条数变化
    onSizeChange(e){
        this.page = 1;
        this.pageSize = e;
        this.getTableData();
    },
    // 搜索
    onSearch(){
        this.page = 1;
        this.getTableData();
    },
    // 当页码发生变化时
    onCurrentChange(e){
        this.page = e;
        this.getTableData();
    },
   }
}
</script>
<style lang="scss" scoped>
.outer{
    .el-form-item{
        margin-right: 20px;
    }
    .pageination{
        display: flex; 
        justify-content: flex-end;
        margin-top: 5px
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }
    .detailTable{
        ::v-deep .el-checkbox__input{
            &.is-checked{
                .el-checkbox__inner{
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }
    .table{
        &::before{
            display: none;
        }
        ::v-deep .el-table__cell{
            >:empty::before{
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
